import React, { useState } from 'react';
import { PopupModal } from '../../../Modals/Index';
import { CheckBox } from '../../../Components';
import './style.css';
const Index = ({ state, setStateFalse, accesses = [], name, id }) => {
    const [roles, setRoles] = useState([...accesses]);
    const onClickHandler = () => {
        console.log('Updating Values for user with id: ' + id);
        console.log(roles);
    };
    const rolesMannagerhandler = (name, currentState) => {
        if (currentState === false) {
            setRoles((prev) => [...prev, name]);
        } else {
            setRoles((prev) => {
                const old = [...prev];
                const index = old.findIndex((ele) => ele === name);
                if (index !== -1) {
                    old.splice(index, 1);
                }
                return old;
            });
        }
    };
    return (
        <PopupModal setStateFalse={setStateFalse} state={state}>
            <div className="popupConatiner">
                <div className="home_head flex-start">
                    <div className="home_head">
                        <div>
                            <h2 className="home_heading">Manage Access for : {name}</h2>
                        </div>
                    </div>
                </div>
                <div className="access-management-popup">
                    <div className="access-management-container">
                        <CheckBox
                            name="Dashboard"
                            value="Dashboard"
                            labeling="Dashboard"
                            checked={roles.findIndex((ele) => ele === 'Dashboard') !== -1}
                            handleChange={rolesMannagerhandler}
                        />
                        <CheckBox
                            name="Billing"
                            value="Billing"
                            labeling="Billing"
                            checked={roles.findIndex((ele) => ele === 'Billing') !== -1}
                            handleChange={rolesMannagerhandler}
                        />
                        <CheckBox
                            name="Merchants"
                            value="Merchants"
                            labeling="Merchants"
                            checked={roles.findIndex((ele) => ele === 'Merchants') !== -1}
                            handleChange={rolesMannagerhandler}
                        />
                        <CheckBox
                            name="Product"
                            value="Product"
                            labeling="Product"
                            checked={roles.findIndex((ele) => ele === 'Product') !== -1}
                            handleChange={rolesMannagerhandler}
                        />
                        <CheckBox
                            name="Access Management"
                            value="Access Management"
                            labeling="Access Management"
                            checked={roles.findIndex((ele) => ele === 'Access Management') !== -1}
                            handleChange={rolesMannagerhandler}
                        />
                        <CheckBox
                            name="Setting"
                            value="Setting"
                            labeling="Setting"
                            checked={roles.findIndex((ele) => ele === 'Setting') !== -1}
                            handleChange={rolesMannagerhandler}
                        />
                        <CheckBox
                            name="Stock Availability"
                            value="Stock Availability"
                            labeling="Stock Availability"
                            checked={roles.findIndex((ele) => ele === 'Stock Availability') !== -1}
                            handleChange={rolesMannagerhandler}
                        />
                    </div>
                    <div className="access-management-popup_footer">
                        <button
                            type="reset"
                            onClick={setStateFalse}
                            className="btn-gray"
                            style={{ marginRight: '1rem' }}
                        >
                            <p>Close</p>
                        </button>
                        <button onClick={onClickHandler} type="submit" className="btn-orange">
                            <p>Confirm</p>
                        </button>
                    </div>
                </div>
            </div>
        </PopupModal>
    );
};

export default Index;
